module.exports = __webpack_public_path__ + "img/puzzle_15.27f71028.png";